const LOCAL_KEY = "_AppLocal";
const SESSION_KEY = "_AppSession";

export enum VariableType {
  Session = 1,
  Local = 2
}

interface VariableStore {
  variables: Record<string, unknown>[];
}

export class Variables {
  public static get<T>(key: string, type: VariableType = VariableType.Session): T | null {
    const storage = Variables.getStorage(type);
    if (storage) {
      const data: VariableStore = JSON.parse(storage);
      const ndx = data.variables.findIndex(v => key in v);
      if (ndx > -1) {
        return data.variables[ndx][key] as T;
      }
    }
    return null;
  }


  public static set(key: string, value: unknown, type: VariableType = VariableType.Session): void {
    const storage = Variables.getStorage(type);
    const obj: Record<string, unknown> = { [key]: value };

    if (!storage) {
      const data: VariableStore = { variables: [obj] };
      Variables.setStorage(type, data);
    } else {
      const data: VariableStore = JSON.parse(storage);
      const ndx = data.variables.findIndex(v => key in v);

      if (ndx > -1) {
        data.variables[ndx][key] = value;
      } else {
        data.variables.push(obj);
      }

      Variables.setStorage(type, data);
    }
  }

  public static clear(key: string = "all", type: VariableType = VariableType.Session): void {
    if (key === "all") {
      if (type === VariableType.Session) {
        sessionStorage.removeItem(SESSION_KEY);
      } else {
        localStorage.removeItem(LOCAL_KEY);
      }
    } else {
      const storage = Variables.getStorage(type);

      if (storage) {
        const data: VariableStore = JSON.parse(storage);
        const ndx = data.variables.findIndex(v => key in v);

        if (ndx > -1) {
          data.variables.splice(ndx, 1); // remove the object at index
          Variables.setStorage(type, data);
        }
      }
    }
  }

  private static getStorage(type: VariableType): string | null {
    return type === VariableType.Session
      ? sessionStorage.getItem(SESSION_KEY)
      : localStorage.getItem(LOCAL_KEY);
  }

  private static setStorage(type: VariableType, data: VariableStore): void {
    const json = JSON.stringify(data);
    if (type === VariableType.Session) {
      sessionStorage.setItem(SESSION_KEY, json);
    } else {
      localStorage.setItem(LOCAL_KEY, json);
    }
  }
}
